
import Vue, { PropType } from 'vue'

type MenuItem = {
  text: string
  to: string
  hasDivider: boolean
  action: Function
  icon: string
  // TODO: our S/CSS variables do not work here, sadly
  dot: string
}

export default Vue.extend({
  name: 'RContextMenu',
  props: {
    items: {
      type: Array as PropType<Array<MenuItem>>,
    },
    position: {
      type: String,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  created(): void {
    document.addEventListener('click', this.closeIfOpen)
  },
  beforeDestroy(): void {
    document.removeEventListener('click', this.closeIfOpen)
  },
  methods: {
    closeIfOpen(e: MouseEvent): void {
      if (this.isOpen) {
        this.isOpen = false
      }
    },
    toggle(): void {
      this.isOpen = !this.isOpen
    },
    /**
     * TODO: ensure the menu does not overflow the viewport horizontally:
     * reposition if it does on created().
     */
    adjustPosition(): void {
      // the menu is positioned against its parent, so the quickest way to find
      // out its position against the whole viewport is to query the trigger
      // const trigger = this.$slots.default[0].elm
      // const tiggerRect = trigger.getBoundingClientRect()
      // ...
    },
  },
})
